<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
@if (isScreenSmall) {
    <fuse-vertical-navigation
        class="dark bg-gray-900 print:hidden"
        [mode]="'over'"
        [name]="'mainNavigation'"
        [navigation]="navigation.default"
        [opened]="false"
    >
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="my-2 flex h-20 items-center px-8 pt-6">
                <img
                    class="w-24"
                    [src]="cdnImages + '/fmf-snf-blanco-md.png'"
                    alt="Logo image"
                />
            </div>
        </ng-container>
    </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="relative z-49 flex h-16 w-full flex-0 items-center bg-pantone7476 px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none sm:h-20 md:px-6 print:hidden"
    >
        @if (!isScreenSmall) {
            <!-- Logo -->
            <div class="mx-2 flex items-center lg:mr-8">
                <div class="hidden lg:flex">
                    <img
                        class="w-28 dark:hidden"
                        [src]="cdnImages + '/fmf-snf-blanco-md.png'"
                    />
                    <img
                        class="hidden w-28 dark:flex"
                        [src]="cdnImages + '/fmf-snf-blanco-md.png'"
                    />
                </div>
                <img
                    class="flex w-28 lg:hidden"
                    [src]="cdnImages + '/fmf-snf-blanco-md.png'"
                />
            </div>
            <!-- Horizontal navigation -->
            <fuse-horizontal-navigation
                class="mr-2"
                [name]="'mainNavigation'"
                [navigation]="navigation.horizontal"
            ></fuse-horizontal-navigation>
        }
        <!-- Navigation toggle button -->
        @if (isScreenSmall) {
            <button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')"
            >
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
        }
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            @if (!isAuthenticated) {
                <a
                    mat-raised-button
                    class="bg-pantone355 text-white"
                    [routerLink]="['/sign-up']"
                >
                    <mat-icon>person_add</mat-icon>
                    Regístrate
                </a>
            }
            <!-- <button class="lg:hidden" mat-icon-button (click)="quickChat.toggle()">
                <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
            </button> -->
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex w-full flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <div
        class="bg-card relative z-49 flex h-14 w-full flex-0 items-center border-t px-4 dark:bg-transparent sm:h-20 md:px-6 print:hidden"
    >
        <span class="text-secondary font-medium"
            >Sistema Nacional de Capacitación SNF &copy; {{ currentYear }}</span
        >

        <a
            class="ml-4 cursor-pointer text-pantone7476"
            (click)="preferentiasCookies()"
        >
            <mat-icon class="mr-1 text-sm text-pantone7476">cookie</mat-icon>
            Preferencias de cookies
        </a>
    </div>
</div>

<!-- Quick chat -->
